module.exports = __webpack_public_path__ + "static/media/mxdfwh.98dd6ad8.png";